module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/2/3-fc38acf1908e46dd092effa7a183ec15.jpg";